<template>
  <div class="pages">
    <div class="pagesContent">
      <top-nav :leftData='leftData' :activeNav='$route.params.pathId'></top-nav>
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{ contentTitle }}</div>
          <div class="engName">{{ englishName }}</div>
        </div>
        <div class="compContent">
          <advantagePosition v-if="$route.params.pathId === 'advantagePosition'"></advantagePosition>
          <advantageMachine v-if="$route.params.pathId === 'advantageMachine'"></advantageMachine>
          <advantageResources v-if="$route.params.pathId === 'advantageResources'"></advantageResources>
          <advantageTrain v-if="$route.params.pathId === 'advantageTrain'"></advantageTrain>
          <advantageProduct v-if="$route.params.pathId === 'advantageProduct'"></advantageProduct>
          <advantageTech v-if="$route.params.pathId === 'advantageTech'"></advantageTech>
          <advantageService v-if="$route.params.pathId === 'advantageService'"></advantageService>
          <advantageMarketing v-if="$route.params.pathId === 'advantageMarketing'"></advantageMarketing>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from '@/components/topNav'
import advantagePosition from '@/components/advantagePosition'
import advantageMachine from '@/components/advantageMachine'
import advantageResources from '@/components/advantageResources'
import advantageTrain from '@/components/advantageTrain'
import advantageMarketing from '@/components/advantageMarketing'
import advantageProduct from '@/components/advantageProduct'
import advantageTech from '@/components/advantageTech'
import advantageService from '@/components/advantageService'
export default {
  name: 'about',
  components: {
    topNav,
    advantagePosition,
    advantageMachine,
    advantageResources,
    advantageTrain,
    advantageProduct,
    advantageTech,
    advantageService,
    advantageMarketing
  },
  data() {
    return {
      leftData: {
        title: '公司优势',
        navs: [{
          name: 'advantagePosition',
          text: '公司定位',
          fatherPath: 'advantage',
          english: 'COMPANY POSITIONING',
          subBa: require('../assets/images/subBanner8.png')
        },
        {
          name: 'advantageMachine',
          text: '合伙机制',
          fatherPath: 'advantage',
          english: 'PARTNERSHIP MECHANISM',
          subBa: require('../assets/images/subBanner9.png')
        },
        {
          name: 'advantageProduct',
          text: '产品赋能',
          fatherPath: 'advantage',
          english: 'PEODUCT EMPOWERMENT',
          subBa: require('../assets/images/subBanner12.png')
        },
        {
          name: 'advantageResources',
          text: '客户赋能',
          fatherPath: 'advantage',
          english: 'CUSTOMER EMPOWERMENT',
          subBa: require('../assets/images/subBanner10.png')
        },
        {
          name: 'advantageTrain',
          text: '培训赋能',
          fatherPath: 'advantage',
          english: 'TRAINING EMPOWERMENT',
          subBa: require('../assets/images/subBanner11.png')
        },
        {
          name: 'advantageMarketing',
          text: '营销赋能',
          fatherPath: 'advantage',
          english: 'MARKETING EMPOWERMENT',
          subBa: require('../assets/images/subBanner21.png')
        },
        {
          name: 'advantageService',
          text: '服务赋能',
          fatherPath: 'advantage',
          english: 'SERVICE EMPOWERMENT',
          subBa: require('../assets/images/subBanner14.png')
        },
        {
          name: 'advantageTech',
          text: '科技赋能',
          fatherPath: 'advantage',
          english: 'TECHNOLOGY EMPOWERMENT',
          subBa: require('../assets/images/subBanner13.png')
        },
        ]
      }
    }
  },
  computed: {
    contentTitle() {
      return this.leftData.navs.find(item => item.name === this.$route.params.pathId).text
    },
    englishName() {
      return this.leftData.navs.find(item => item.name === this.$route.params.pathId).english
    }
  },
  created() {
  },
  mounted() { },
  methods: {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.compContent {}
</style>